module.exports = __webpack_public_path__ + "img/polygraph.55b76965.svg";